var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEasyData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 149,
    viewBox: "0 0 149 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.02 89.9594C128.862 89.9594 149 69.8213 149 44.9797C149 20.1381 128.862 0 104.02 0C79.1786 0 59.0405 20.1381 59.0405 44.9797C59.0405 69.8213 79.1786 89.9594 104.02 89.9594Z",
    fill: "url(#paint0_linear_181_58)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2595 104.72C114.101 104.72 134.239 84.5823 134.239 59.7407C134.239 34.8991 114.101 14.761 89.2595 14.761C64.4179 14.761 44.2798 34.8991 44.2798 59.7407C44.2798 84.5823 64.4179 104.72 89.2595 104.72Z",
    fill: "url(#paint1_linear_181_58)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4983 119.478C99.3399 119.478 119.478 99.3401 119.478 74.4985C119.478 49.6569 99.3399 29.5188 74.4983 29.5188C49.6567 29.5188 29.5186 49.6569 29.5186 74.4985C29.5186 99.3401 49.6567 119.478 74.4983 119.478Z",
    fill: "url(#paint2_linear_181_58)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7405 134.239C84.5821 134.239 104.72 114.101 104.72 89.2593C104.72 64.4176 84.5821 44.2795 59.7405 44.2795C34.8988 44.2795 14.7607 64.4176 14.7607 89.2593C14.7607 114.101 34.8988 134.239 59.7405 134.239Z",
    fill: "url(#paint3_linear_181_58)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9797 149C69.8213 149 89.9594 128.862 89.9594 104.02C89.9594 79.1786 69.8213 59.0405 44.9797 59.0405C20.1381 59.0405 0 79.1786 0 104.02C0 128.862 20.1381 149 44.9797 149Z",
    fill: "url(#paint4_linear_181_58)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_181_58",
    x1: 59.0374,
    y1: 44.9797,
    x2: 149,
    y2: 44.9797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DEDF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010F4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_181_58",
    x1: 44.2798,
    y1: 59.7407,
    x2: 134.239,
    y2: 59.7407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DEDF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010F4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_181_58",
    x1: 29.5186,
    y1: 74.4985,
    x2: 119.481,
    y2: 74.4985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DEDF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010F4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_181_58",
    x1: 14.7607,
    y1: 89.2593,
    x2: 104.72,
    y2: 89.2593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DEDF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010F4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_181_58",
    x1: 0,
    y1: 104.02,
    x2: 89.9626,
    y2: 104.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DEDF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010F4A",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasyData);
export default __webpack_public_path__ + "static/media/easy-data.ad763789066b1997276c964af8f582be.svg";
export { ForwardRef as ReactComponent };